import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, ModalController } from '@ionic/angular';
import { HelperProvider } from 'src/app/providers/helper.provider';
import { environment } from 'src/environments/environment';
import { UrgentOrderPage } from '../urgent-order/urgent-order.page';
import { PickupConfirmPage } from '../pickup-confirm/pickup-confirm.page';
import { SupportTicketPageModule } from '../support-ticket/support-ticket.module';
import { PaymentHistoryListPageModule } from '../payment-history-list/payment-history-list.module';
import { PickupHistoryListPage } from '../pickup-history-list/pickup-history-list.page';
import { ContractListPage } from '../contract-list/contract-list.page';
import { SupportRequestListPage } from '../support-request-list/support-request-list.page';
import { SupportRequestDetailPage } from '../support-request-detail/support-request-detail.page';
import { ShareAccessListPage } from '../share-access-list/share-access-list.page';
import { ShareAccessFormPage } from '../share-access-form/share-access-form.page';
import { PaymentHistoryListPage } from '../payment-history-list/payment-history-list.page';
import { SupportTicketPage } from '../support-ticket/support-ticket.page';
import { AddMoneyPage } from '../add-money/add-money.page';
import { OwnerDetailPage } from '../owner-detail/owner-detail.page';
import { NotificationSettingsPage } from '../notification-settings/notification-settings.page';

@Component({
  selector: 'app-device-detail',
  templateUrl: './device-detail.page.html',
  styleUrls: ['./device-detail.page.scss'],
})
export class DeviceDetailPage implements OnInit {

  SENSOR_REGISTER = '64faf13e88863301c2d53fc4';
  ORDER_ID = '64fb110f88863301c2d54e34';

  deviceData: any = {};
  userData: any;
  defaultOffice = '64faefc488863301c2d53f93';
  currentView = 'general';
  orderList: any = [];

  constructor(
    private helperProvider: HelperProvider,
    private alertController: AlertController,
    private router: Router,
    private route: ActivatedRoute,
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
    this.getUserData();
    this.initData();
  }

  async initData() {
    const lastView = this.currentView;
    this.currentView = 'loading';
    await Promise.all([
      this.getDeviceData(),
      this.getOrderList()
    ]);
    this.currentView = lastView;
  }

  getUserData() {
    if (localStorage.getItem('ngStorage-profile')) {
      this.userData = JSON.parse(localStorage.getItem('ngStorage-profile'));
    }
  }

  async getDeviceData() {
    this.deviceData = await this.getMyData({ type: 'getOne', subType: 'withForm', recId: this.route.snapshot.params.sensorId, regId: this.SENSOR_REGISTER });
  }

  async getOrderList() {
    this.orderList = await this.getMyData({ type: 'getList', officeId: this.defaultOffice, regId: this.ORDER_ID, filter: { sensorId: this.route.snapshot.params.sensorId }, sort: { _id: 1 } });
  }


  async getMyData(data) {
    try {
      return await this.helperProvider.postRequest(`${environment.serverUrl}api/get-my-data`, data);
    } catch (error) {
      console.log('error in my data call', error);
      this.showAlert(error);
      return null;
    }
  }

  async showAlert(message: any) {
    return new Promise(async (resolve, reject) => {
      const alert = await this.alertController.create({
        header: message,
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            handler: () => {
              resolve(null);
            }
          },
          {
            text: 'OK',
            handler: (data) => {
              resolve(true);
            },
          },
        ],
      });

      await alert.present();
    });
  }

  itemClicked(item) {
    this.router.navigateByUrl(`/device/${item.sensorId}`);
  }

  goBack() {
    this.router.navigateByUrl('/device-list');
  }

  async openModal(type: any) {
    let comp;

    switch (type) {
      case 'urgentOrder':
        comp = UrgentOrderPage;
        break;
      case 'pickupConfirm':
        comp = PickupConfirmPage;
        break;
      case 'supportTicket':
        comp = SupportTicketPage;
        break;
      case 'paymentList':
        comp = PaymentHistoryListPage;
        break;
      case 'pickupList':
        comp = PickupHistoryListPage;
        break;
      case 'contractList':
        comp = ContractListPage;
        break;
      case 'supportRequestList':
        comp = SupportRequestListPage;
        break;
      case 'supportRequestDetail':
        comp = SupportRequestDetailPage;
        break;
      case 'shareAccessList':
        comp = ShareAccessListPage;
        break;
      case 'shareAccessForm':
        comp = ShareAccessFormPage;
        break;
      case 'addMoney':
        comp = AddMoneyPage;
        break;
      case 'ownerDetail':
        comp = OwnerDetailPage;
        break;
      case 'notificationSettings':
        comp = NotificationSettingsPage;
        break;
    }

    console.log("this.deviceData.actualSaldo", this.deviceData.actualSaldo, this.deviceData.minSaldoRequired);
    if (type === 'urgentOrder' || type === 'pickupConfirm') {
        if ((this.deviceData.actualSaldo < this.deviceData.minSaldoRequired) || !this.deviceData.actualSaldo) {
            comp = UrgentOrderPage;
        } else {
            comp = PickupConfirmPage;
        }
    }


    const modal = await this.modalCtrl.create({
      component: comp,
      backdropDismiss: false,
      componentProps: {
        data: this.deviceData
      }
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    console.log("refresh", data);

    if (data?.refresh) {
      this.initData();
    }
  }

}
